import React, { useState } from 'react';
import { IonMenuButton } from '@ionic/react';
import { AllieLoading, Header } from '@allie/app-ui-lib';
import { useAppTranslations } from '../../../hooks';
import { useHeader } from '../hooks/useHeader';

export const HeaderWrapper: React.FC = () => {
  const { CHANGING_LANG } = useAppTranslations();
  const [changingLang, setChangingLang] = useState(false);
  const { headerProps } = useHeader(setChangingLang);

  return (
    <>
      <AllieLoading isOpen={changingLang} message={CHANGING_LANG} />
      <Header
        {...headerProps}
        contentButtonMenu={
          <IonMenuButton menu="sidebar-menu" data-testid="menu-button"/>
        }
      />
    </>
  );
};
